/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type { ArchivedPlans } from '@jira/spa-apps__admin-pages-archived-plans/src/AdminPagesArchivedPlansArchivedPlans.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyArchivedPlans: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ArchivedPlans
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-archived-plans", jiraSpaEntry: "async-archived-plans" */ '@jira/spa-apps__admin-pages-archived-plans/src/AdminPagesArchivedPlansArchivedPlans.tsx'
		).then((module) => module.ArchivedPlans),
	),
);

export const ArchivedPlansDirectory = (): React.JSX.Element => (
	<LazyPage Page={LazyArchivedPlans} pageId="archived-plans" shouldShowSpinner />
);
